"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const companyQuery_1 = require("../../../../queries/companyQuery");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const zustandStore_1 = require("../../../../zustandStore");
const selectAside_1 = __importDefault(require("../selectAside"));
const onApproverAdded = ({ teamId, setUserTeamProperty, setIsUserApproverAsideOpen, approver, currentSelectedUser, }) => {
    if (!currentSelectedUser) {
        return;
    }
    setUserTeamProperty.mutate({
        userId: currentSelectedUser?.userId,
        teamId,
        propertyKey: appConstants_1.userTeamProperties.all.defaultApprover,
        propertyValue: approver?.userId,
    });
    setIsUserApproverAsideOpen(false);
};
const AddDefaultManagerAside = () => {
    const setUserTeamProperty = (0, teamQuery_1.useSetUserTeamPropertyQuery)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [approvers, setApprovers] = (0, react_1.useState)([]);
    const isOpenApproverAside = (0, zustandStore_1.useZustand)(state => state.aside.userApprover.isOpen);
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { setIsUserApproverAsideOpen } = (0, zustandStore_1.useZustand)();
    const currentSelectedUser = (0, zustandStore_1.useZustand)(state => state.aside.userDetails.user);
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(currentUser?.companyAccountId || '', { cardprovider: 'tsgo-cardprovider' }));
    const { data: teamApprovers } = (0, paymentQuery_1.useGetTeamApproversQuery)({
        excludeSelf: false,
        excludeOutOfOffice: true,
        teamId: teamId?.[0] || '',
    });
    const isAmexCardProvider = companyPropertiesData?.cardprovider === 'AMEX';
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!teamApprovers?.length) {
            return;
        }
        const amexApprovers = teamApprovers.filter(approver => {
            return (approver.roles?.some(role => role.roleId === 'team_admin') ||
                approver.roles?.some(role => role.roleId === 'manager'));
        });
        const hsbcApprovers = teamApprovers
            .filter(approver => approver?.userId !== currentSelectedUser?.userId)
            .filter(approver => {
            return (approver.roles?.some(role => role.roleId === 'team_admin') ||
                approver.roles?.some(role => role.roleId === 'manager') ||
                approver.roles?.some(role => role.roleId === 'company_admin'));
        });
        const approversByCardProvider = isAmexCardProvider ? amexApprovers || [] : hsbcApprovers || [];
        const data = approversByCardProvider.map(approver => {
            return { ...approver, label: approver.fullName };
        });
        setApprovers(data);
        setIsLoading(false);
    }, [currentSelectedUser?.userId, isAmexCardProvider, teamApprovers]);
    const onSelect = ({ option }) => {
        onApproverAdded({
            teamId,
            setUserTeamProperty,
            setIsUserApproverAsideOpen,
            approver: option,
            currentSelectedUser,
        });
        setIsUserApproverAsideOpen(false);
    };
    return ((0, jsx_runtime_1.jsx)(selectAside_1.default, { emptyMessage: strings_1.messageStrings.EMPTY_LIST_MESSAGE, isLoading: isLoading, isOpen: isOpenApproverAside, onClose: () => setIsUserApproverAsideOpen(false), onSelect: e => onSelect(e), options: approvers || [], title: strings_1.approvalsStrings.SELECT_APPROVER }));
};
exports.default = AddDefaultManagerAside;
